// This list is duplicated in scss
// @see prb-style-library/variables.scss to update.
export const map = [
  '#D8EDC5',
  '#74CFCF',
  '#00ACD2',
  '#1667AA',
  '#1F278E',
  '#10154E',
  '#000000',
];

export const noData = '#DDDDDD';

export const hover = '#717073'; // prb-gray, @see prb-style-library/variables

export const chart = [];

export const getRandomMapColor = () => map[Math.floor(Math.random() * 6)];

export default { map, chart, noData };



// WEBPACK FOOTER //
// ./app/config/colors.js